var _circle, _circle2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#80CB7B",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 40,
    fill: "#80CB7B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "success_svg__a",
    width: 40,
    height: 40,
    x: 50,
    y: 50,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M50 50h40v40H50z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#success_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.805 80.056a2.15 2.15 0 0 1-1.528-.64L56.861 72a2.1 2.1 0 0 1-.632-1.562 2.15 2.15 0 0 1 .645-1.563 2.12 2.12 0 0 1 1.556-.639 2.2 2.2 0 0 1 1.583.639l5.792 5.792 14.18-14.153a2.18 2.18 0 0 1 1.55-.66q.91-.021 1.562.66.639.639.639 1.57 0 .93-.64 1.569L67.334 79.417a2.14 2.14 0 0 1-1.528.639"
  }))));
};
export default SvgSuccess;